import type { ISaleRepository, ReturnSaleInput } from '@/features/sale/domain/repositories/ISaleRepository.js';

export function createDeleteSaleUseCase(deps: { saleRepository: ISaleRepository }) {
  return async function deleteSaleUseCase(input: ReturnSaleInput): Promise<boolean> {
    return deps.saleRepository.deleteSale(input);
  };
}

export type DeleteSaleUseCase = ReturnType<typeof createDeleteSaleUseCase>;
